import React from "react";
import { useAppSelector } from "../../../../../app/hooks";
import { useMyProfileQuery } from "../../../../../services/profileService/profile-api";
import { useFindVarianceRequestQuery } from "../../../../../services/varianceService/variance-api";
import { CircularProgress, Typography, List, ListItem, ListItemText, ListItemIcon, Grid, Avatar, Divider, ListItemButton, ListItemSecondaryAction } from "@mui/material";
import { DefaultAssignedUser } from "../../../../../services/varianceService/model/varianceRequest/AssignedUser";
import { AccountCircle } from "@mui/icons-material";
import { VariancePendingApproveBtn } from "../commands/StatusChanges/VariancePendingApproveBtn";
import { IncidentUnAssignUserBtn } from "../commands/AssignUser/IncidentUnAssignUserBtn";
import { PermissionChecker } from "../../../../../services/varianceService/util/PermissionChecker";

type AssignedStatusViewProps = {
  varianceId: string;
};

function AssignedStatusView({ varianceId }: AssignedStatusViewProps) {
  const profile = useMyProfileQuery();
  const [notify, setNotify] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const { data: varianceRequest, isLoading } = useFindVarianceRequestQuery(varianceId);

  if (isLoading) {
    return <CircularProgress />;
  }

  const assignedUsers = varianceRequest?.assignedUsers || [DefaultAssignedUser()];
  const canUnAssign = PermissionChecker.isVarianceAdmin(profile.data, varianceRequest?.center) || PermissionChecker.isVarianceQualityTeam(profile.data, varianceRequest?.center);
  const isCompletedOrCancelled = varianceRequest?.status === "Complete" || varianceRequest?.status === "Cancelled";

  return (
    <div>
      <Grid container spacing={2} justifyContent="center" style={{ marginTop: "20px", marginBottom: "20px" }}>
        <Grid item xs={8} spacing={8}>
          <List style={{ backgroundColor: "#f5f5f5" }}>
            {assignedUsers.length === 0 ? (
              <Typography variant="h6" align="center" style={{ padding: "20px" }}>
                No assigned users
              </Typography>
            ) : null}
            {assignedUsers.map((user, index) => (
              <React.Fragment key={user.upn}>
                <ListItem>              
                <Grid item xs={4}>
                  <ListItemIcon>
                    <Avatar style={{ backgroundColor: "#62BCBD" }}>
                      <AccountCircle />
                    </Avatar>
                  </ListItemIcon>                  <ListItemText
                  
                    primary={user.displayName}
                    secondary={user.isClosed ? "Completed" : assignedUsers.some(u => u.isClosed) ? "Not Needed" : "Pending"}
                  />
                </Grid>
                  <Grid container alignItems="center">
                    {profile.data?.upn === user.upn && !user.isClosed && !isCompletedOrCancelled && (
                      <Grid item>
                        <ListItemButton>
                          <VariancePendingApproveBtn
                            setNotify={setNotify}
                            setMessage={setMessage}
                          />
                        </ListItemButton>
                      </Grid>
                    )}
                    {canUnAssign && !isCompletedOrCancelled && !user.isClosed && (
                      <Grid item>
                        <IncidentUnAssignUserBtn
                          profile={profile.data}
                          assignedUser={user}
                        />
                      </Grid>
                    )}
                  </Grid>
                </ListItem>
                {index < assignedUsers.length - 1 && (
                  <Divider style={{ backgroundColor: "#62BCBD" }} />
                )}
              </React.Fragment>
            ))}
          </List>
        </Grid>
      </Grid>
    </div>
  );
}

export { AssignedStatusView };
